module.exports = Jsw.skinUrl + "/images/sticker-collection/sticker/player.png?9c045e678cba88f439071019d223ea17";